module.exports = __webpack_public_path__ + "static/media/user-list.202dc26e.png";